// extracted by mini-css-extract-plugin
module.exports = {"toggleContainer":"toggle-module__toggleContainer--aUCij","switch":"toggle-module__switch--2nY4E","slider":"toggle-module__slider--1IfzM"};